// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {AssetHash} from './asset-hash.js'

export class AssetCloudPersisted {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): AssetCloudPersisted {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsAssetCloudPersisted(bb: flatbuffers.ByteBuffer, obj?: AssetCloudPersisted): AssetCloudPersisted {
    return (obj || new AssetCloudPersisted()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsAssetCloudPersisted(
    bb: flatbuffers.ByteBuffer,
    obj?: AssetCloudPersisted
  ): AssetCloudPersisted {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new AssetCloudPersisted()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  assetHash(obj?: AssetHash): AssetHash | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? (obj || new AssetHash()).__init(this.bb_pos + offset, this.bb!) : null
  }

  static startAssetCloudPersisted(builder: flatbuffers.Builder) {
    builder.startObject(1)
  }

  static addAssetHash(builder: flatbuffers.Builder, assetHashOffset: flatbuffers.Offset) {
    builder.addFieldStruct(0, assetHashOffset, 0)
  }

  static endAssetCloudPersisted(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    builder.requiredField(offset, 4) // asset_hash
    return offset
  }

  static createAssetCloudPersisted(
    builder: flatbuffers.Builder,
    assetHashOffset: flatbuffers.Offset
  ): flatbuffers.Offset {
    AssetCloudPersisted.startAssetCloudPersisted(builder)
    AssetCloudPersisted.addAssetHash(builder, assetHashOffset)
    return AssetCloudPersisted.endAssetCloudPersisted(builder)
  }
}
